module.exports = __webpack_public_path__ + "img/la_verite_sm.0a34fdcb.png";